import Cookies from 'js-cookie';
import { useRouter } from 'next/navigation';

import { ROUTES } from '@shared/constants/routes';
import { useAppDispatch } from '@shared/hooks/redux';
import { Button } from '@shared/ui/Button';
import {
  closeAboutCookieModal,
  closeAcceptCookieModal,
  openAboutCookieModal
} from '@widgets/CookieModals/model/slice/cookieModalSlice';
import { ModalWrap } from '@widgets/CookieModals/ui/ModalWrap/ModalWrap';

import cls from './AcceptCookieModal.module.scss';

export const AcceptCookieModal = () => {
  const dispatch = useAppDispatch();

  const { push } = useRouter();

  const handleOpenAboutCookie = () => {
    dispatch(openAboutCookieModal());
  };

  const onClickOkButton = () => {
    Cookies.set('cookieAgreement', '1');
    dispatch(closeAboutCookieModal());
    dispatch(closeAcceptCookieModal());
  };

  const onClickConsentPersonalInfoLink = () => {
    push(ROUTES.CONSENT_PERSONAL_DATA_METRIC);
  };

  return (
    <ModalWrap fixed={false}>
      <div
        data-testid="accept-cookie-modal"
        className={cls.wrap}
      >
        <div className={cls.text}>
          Продолжая использовать наш сайт вы соглашаетесь на обработку{' '}
          <span
            data-testid="about-cookie-modal-link"
            className={cls.accent}
            onClick={handleOpenAboutCookie}
          >
            файлов cookie
          </span>
          , а так же соглашаетесь на обработку{' '}
          <span
            data-testid="about-cookie-modal-link-personal-data"
            className={cls.accent}
            onClick={onClickConsentPersonalInfoLink}
          >
            персональных данных метрическими программами
          </span>
        </div>
        <Button
          testId={'accept-cookie-modal-ok-button'}
          aria-label={'ОК'}
          variant={'primary'}
          onClick={onClickOkButton}
          size={'s'}
        >
          ОК
        </Button>
      </div>
    </ModalWrap>
  );
};
